<template>
  <a class="promo-card" :href="promoCard.targetUrl" v-data-test-id="'promo-card'" @click="trackClick">
    <ImageContentful
      :src="promoCard.imageUrl"
      containerSelector=".card__image"
      :isBackgroundImage="true"
      :options="{ setHeight: false }"
      class="promo-card__image"
    />
    <div class="promo-card__content">
      <div class="promo-card__text" :class="'promo-card__text--' + promoCard.variant">
        {{ promoCard.text }}
      </div>
      <button class="promo-card__cta" :class="'promo-card__cta--' + promoCard.variant">
        {{ promoCard.ctaText }}
      </button>
    </div>
  </a>
</template>

<script>
import ImageContentful from '@/components/_shared/ImageContentful.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'PromoCard',
  components: { ImageContentful },

  props: {
    promoCard: {
      type: Object,
      required: true,
    },

    index: {
      type: Number,
      required: true,
    },
  },

  computed: {
    ...mapGetters({ currentBreakpoint: 'filter/currentBreakpoint' }),
  },

  methods: {
    trackClick() {
      const position = this.currentBreakpoint.promoPositions.indexOf(this.index) + 1
      On.Analytics.trackPromoCard.click(
        `Promocard Position: ${position}, Target: ${this.promoCard.targetUrl}`
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/components/FilterPage/Products/Card/card-basic.scss';

.promo-card {
  @extend %card-basic;
  min-height: 600px;

  &:hover {
    .promo-card__cta--dark {
      background-color: $color-grey-dark-1;
    }

    .promo-card__cta--light {
      background-color: rgba($color-white, 0.85);
    }

    .promo-card__cta--transparent {
      background-color: rgba($color-white, 0.1);
    }
  }

  &__image {
    flex: 1;
    background-size: cover;
    background-position: center center;
  }

  &__content {
    position: absolute;
    bottom: 0;
  }

  &__text {
    font-family: $font-family-neutraface;
    font-size: $font-size-heading-large;
    color: $color-grey-dark-2;
    letter-spacing: $font-spacing-small;
    line-height: $line-height-small;
    margin: 0 40px;

    &--light,
    &--transparent {
      color: $color-white;
    }
  }

  &__cta {
    margin: 30px 40px 40px;
    padding: 17px 24px 16px;
    line-height: 1;
    color: $color-white;
    background-color: $color-grey-dark-2;
    transition: background-color $transition-time ease-in-out;

    &--transparent {
      background-color: transparent;
      border: 2px solid $color-white;
    }

    &--light {
      color: $color-grey-dark-2;
      background-color: $color-white;
    }
  }
}
</style>
